<div class="aiff-setting-detail-container" [testId]="'aiff-setting-detail-container'">
  <nz-spin [nzSpinning]="loading" [testId]="'aiff-setting-detail-loading'">
    <div class="modal-header" [testId]="'aiff-setting-detail-modal-header'">
      <h4 class="modal-title" [testId]="'aiff-setting-detail-modal-title'">{{
        isAdd ? ('tenant.aiff.setting.create' | i18n) : ('tenant.aiff.setting.edit' | i18n)
      }}</h4>
      <button class="close-btn" nz-button nzType="text" (click)="cancel()" [testId]="'aiff-setting-detail-close-button'">
        <i nz-icon nzType="close" nzTheme="outline" [testId]="'aiff-setting-detail-close-icon'"></i>
      </button>
    </div>
    <form nz-form [formGroup]="settingForm" (ngSubmit)="saveSetting()" nzLayout="horizontal" [testId]="'aiff-setting-detail-form'">
      <!-- 基本信息 -->
      <div class="form-section" [testId]="'aiff-setting-detail-form-section'">
        <div class="section-header" [testId]="'aiff-setting-detail-section-header'">
          <h3 class="section-title" [testId]="'aiff-setting-detail-section-title'">{{ 'tenant.aiff.setting.basic.info' | i18n }}</h3>
          <div class="header-buttons" [testId]="'aiff-setting-detail-header-buttons'">
            <button nz-button nzType="primary" [nzLoading]="submitting" type="submit" [testId]="'aiff-setting-detail-save-button'">{{
              'common.save' | i18n
            }}</button>
          </div>
        </div>

        <div nz-row [testId]="'aiff-setting-detail-form-row'">
          <div nz-col [nzSpan]="24" [testId]="'aiff-setting-detail-support-device-col'">
            <nz-form-item [testId]="'aiff-setting-detail-support-device-form-item'">
              <nz-form-label
                nzRequired
                nzFor="supportDevice"
                [nzSm]="4"
                [nzXs]="24"
                [testId]="'aiff-setting-detail-support-device-label'"
                >{{ 'tenant.aiff.setting.support.device' | i18n }}</nz-form-label
              >
              <nz-form-control
                [nzSm]="20"
                [nzXs]="24"
                [nzErrorTip]="'tenant.aiff.setting.support.device.required' | i18n"
                [testId]="'aiff-setting-detail-support-device-control'"
              >
                <nz-select
                  formControlName="supportDevice"
                  id="supportDevice"
                  [nzPlaceHolder]="'tenant.aiff.setting.support.device.placeholder' | i18n"
                  [testId]="'aiff-setting-detail-support-device-select'"
                >
                  <nz-option
                    *ngFor="let option of deviceOptions"
                    [nzValue]="option.value"
                    [nzLabel]="option.label"
                    [testId]="'aiff-setting-detail-support-device-option-' + option.value"
                  />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzSpan]="24" [testId]="'aiff-setting-detail-display-type-col'">
            <nz-form-item [testId]="'aiff-setting-detail-display-type-form-item'">
              <nz-form-label nzRequired nzFor="displayType" [nzSm]="4" [nzXs]="24" [testId]="'aiff-setting-detail-display-type-label'">{{
                'tenant.aiff.setting.type' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzSm]="20"
                [nzXs]="24"
                [nzErrorTip]="'tenant.aiff.setting.type.required' | i18n"
                [testId]="'aiff-setting-detail-display-type-control'"
              >
                <nz-select
                  formControlName="displayType"
                  id="displayType"
                  [nzPlaceHolder]="'tenant.aiff.setting.type.placeholder' | i18n"
                  [testId]="'aiff-setting-detail-display-type-select'"
                >
                  <nz-option
                    *ngFor="let option of displayTypeOptions"
                    [nzValue]="option.value"
                    [nzLabel]="option.label"
                    [testId]="'aiff-setting-detail-display-type-option-' + option.value"
                  />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzSpan]="24" [testId]="'aiff-setting-detail-popup-size-col'">
            <nz-form-item [testId]="'aiff-setting-detail-popup-size-form-item'">
              <nz-form-label nzRequired nzFor="popupSize" [nzSm]="4" [nzXs]="24" [testId]="'aiff-setting-detail-popup-size-label'">{{
                'tenant.aiff.setting.popup.size' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzSm]="20"
                [nzXs]="24"
                [nzErrorTip]="'tenant.aiff.setting.popup.size.required' | i18n"
                [testId]="'aiff-setting-detail-popup-size-control'"
              >
                <nz-select
                  formControlName="popupSize"
                  id="popupSize"
                  [nzPlaceHolder]="'tenant.aiff.setting.popup.size.placeholder' | i18n"
                  [testId]="'aiff-setting-detail-popup-size-select'"
                >
                  <nz-option
                    *ngFor="let option of popupSizeOptions"
                    [nzValue]="option.value"
                    [nzLabel]="option.label"
                    [testId]="'aiff-setting-detail-popup-size-option-' + option.value"
                  />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div
            nz-col
            [nzSpan]="24"
            *ngIf="settingForm.get('displayType')?.value === 'Room'"
            [testId]="'aiff-setting-detail-display-location-col'"
          >
            <nz-form-item [testId]="'aiff-setting-detail-display-location-form-item'">
              <nz-form-label
                nzRequired
                nzFor="displayLocation"
                [nzSm]="4"
                [nzXs]="24"
                [testId]="'aiff-setting-detail-display-location-label'"
                >{{ 'tenant.aiff.setting.embed.location' | i18n }}</nz-form-label
              >
              <nz-form-control
                [nzSm]="20"
                [nzXs]="24"
                [nzErrorTip]="'tenant.aiff.setting.embed.location.required' | i18n"
                [testId]="'aiff-setting-detail-display-location-control'"
              >
                <nz-select
                  formControlName="displayLocation"
                  id="displayLocation"
                  [nzPlaceHolder]="'tenant.aiff.setting.embed.location.placeholder' | i18n"
                  [testId]="'aiff-setting-detail-display-location-select'"
                >
                  <nz-option
                    *ngFor="let option of displayLocationOptions"
                    [nzValue]="option.value"
                    [nzLabel]="option.label"
                    [testId]="'aiff-setting-detail-display-location-option-' + option.value"
                  />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzSpan]="24" *ngIf="settingForm.get('displayType')?.value === 'Room'" [testId]="'aiff-setting-detail-room-type-col'">
            <nz-form-item [testId]="'aiff-setting-detail-room-type-form-item'">
              <nz-form-label
                [nzRequired]="settingForm.get('displayType')?.value === 'Room'"
                nzFor="roomType"
                [nzSm]="4"
                [nzXs]="24"
                [testId]="'aiff-setting-detail-room-type-label'"
                >{{ 'tenant.aiff.setting.room.type' | i18n }}</nz-form-label
              >
              <nz-form-control
                [nzSm]="20"
                [nzXs]="24"
                [nzErrorTip]="'tenant.aiff.setting.room.type.required' | i18n"
                [testId]="'aiff-setting-detail-room-type-control'"
              >
                <nz-checkbox-group
                  formControlName="roomType"
                  [nzOptions]="roomTypeOptions"
                  [testId]="'aiff-setting-detail-room-type-checkbox-group'"
                />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzSpan]="24" [testId]="'aiff-setting-detail-service-number-col'">
            <nz-form-item [testId]="'aiff-setting-detail-service-number-form-item'">
              <nz-form-label nzFor="serviceNumberIds" [nzSm]="4" [nzXs]="24" [testId]="'aiff-setting-detail-service-number-label'">{{
                'tenant.aiff.setting.service.number' | i18n
              }}</nz-form-label>
              <nz-form-control [nzSm]="20" [nzXs]="24" [testId]="'aiff-setting-detail-service-number-control'">
                <div class="service-number-selector" [testId]="'aiff-setting-detail-service-number-selector'">
                  <button
                    nz-button
                    nzType="default"
                    type="button"
                    class="select-service-btn"
                    (click)="openServiceNumberSelector()"
                    [testId]="'aiff-setting-detail-service-number-browse-button'"
                  >
                    <i nz-icon nzType="team" nzTheme="outline" [testId]="'aiff-setting-detail-service-number-browse-icon'"></i>
                    {{ 'tenant.aiff.setting.service.number.browse' | i18n }}
                  </button>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
    </form>
  </nz-spin>
</div>
